import { Route } from '@angular/router';
import { HomeComponent } from './feature/home/home.component';
import { TermAndConditionComponent } from './feature/term-and-condition/term-and-condition.component';
import { PrivacyPolicyComponent } from './feature/privacy-policy/privacy-policy.component';
import { CookiesPolicyComponent } from './feature/cookies-policy/cookies-policy.component';
import { Lib404PageNotFoundComponent } from '@web-nx-ng-tsc/web-promo-shared-ui';

export enum ROUTER_TOKENS {
  NITTO = 'NITTO',
  // HOME = 'home',
  PRODUCTS = 'products',
  PROMOTIONS = 'promotions',
  VIDEOS = 'videos',
  ARTICLE = 'article',
  NEWS = 'news',
  BRANCHES = 'branches',
  ABOUT_US = 'about-us',
  FRANCHISE = 'franchise',
  AFTER_SALE_SERVICE = 'after-sale-service',
  WARRANTY_POLICY = 'warrantyPolicy',
  CONTACT_US = 'contact-us',
  TERM_AND_CONDITION = 'term-and-condition',
  PRIVACY_POLICY = 'privacy-policy',
  COOKIES_POLICY = 'cookies-policy',
  TIRE = 'tire',
  LUBRICANT = 'lubricant',
  BREAK = 'brake',
  GALLERY = 'gallery',
}

export const appRoutes: Route[] = [
  // {
  //   path: '',
  //   redirectTo: ROUTER_TOKENS.HOME,
  //   pathMatch: 'full',
  // },
  {
    path: '',
    component: HomeComponent,
    data: {
      name: ROUTER_TOKENS.NITTO,
      title: 'NITTO Tire Thailand | ยางสมรรถนะสูง สปอร์ต ทนทาน',
      description:
        'เว็บไซต์ทางการของ NITTO Tire Thailand ครบทั้งซื้อยาง และข้อมูลสเปกสำหรับเก๋ง กระบะ SUV และ 4x4 โดดเด่นเรื่องการยึดเกาะและความทนทานแบบสปอร์ต ค้นหารุ่นที่ใช่ เช็กราคา เลือกสาขาและโทรจองคิวนัดหมายได้ทันที',
      keywords:
        'ยาง nitto,ยาง nitto ราคา,NITTO Tire Thailand,ยางสมรรถนะสูง nitto,เปลี่ยนยางรถยนต์ nitto,ราคายางรถยนต์ nitto',
      robots: 'index, follow',
      canonical: 'https://nittotire.in.th',
      publisher: 'NITTO',
    },
  },
  {
    path: ROUTER_TOKENS.TERM_AND_CONDITION,
    component: TermAndConditionComponent,
    data: {
      name: ROUTER_TOKENS.NITTO,
      title: 'ข้อกำหนดและเงื่อนไขการใช้บริการ | NITTO Tire Thailand',
      description:
        'เอกสารข้อกำหนดและเงื่อนไขการใช้เว็บไซต์/บริการของ NITTO ครอบคลุมขอบเขตการใช้งาน สิทธิและหน้าที่ของผู้ใช้ หลักเกณฑ์ทางกฎหมาย ข้อจำกัดความรับผิด และแนวทางการติดต่อ เพื่อความโปร่งใสและความมั่นใจในการใช้งานทุกส่วนของเว็บไซต์ | NITTO Tire Thailand',
    },
  },
  {
    path: ROUTER_TOKENS.PRIVACY_POLICY,
    component: PrivacyPolicyComponent,
    data: {
      name: ROUTER_TOKENS.NITTO,
      title: 'นโยบายความเป็นส่วนตัว | NITTO Tire Thailand',
      description:
        'อธิบายการเก็บ ใช้ เปิดเผย และคุ้มครองข้อมูลส่วนบุคคลตามกฎหมายที่เกี่ยวข้อง ระบุสิทธิของเจ้าของข้อมูล ช่องทางติดต่อ และมาตรการรักษาความปลอดภัย ให้คุณใช้งานเว็บไซต์และบริการของ NITTO ได้อย่างมั่นใจ โปร่งใส และสอดคล้องข้อกำหนดเสมอ | NITTO Tire Thailand',
    },
  },
  {
    path: ROUTER_TOKENS.COOKIES_POLICY,
    component: CookiesPolicyComponent,
    data: {
      name: ROUTER_TOKENS.NITTO,
      title: 'นโยบายคุกกี้ | NITTO Tire Thailand',
      description:
        'ชี้แจงประเภทคุกกี้ วัตถุประสงค์ด้านฟังก์ชัน การวิเคราะห์ และการโฆษณา อธิบายผลต่อประสบการณ์ผู้ใช้ พร้อมวิธีตั้งค่า/จัดการความยินยอมในเบราว์เซอร์ คุณสามารถปรับเปลี่ยนการยินยอมได้ทุกเมื่อ เพื่อให้การใช้งานเว็บไซต์เหมาะกับความต้องการมากที่สุด | NITTO Tire Thailand',
    },
  },
  {
    path: ROUTER_TOKENS.PRODUCTS,
    loadChildren: () => import('./feature/products/products.routes').then((m) => m.productRoutes),
  },
  {
    path: ROUTER_TOKENS.PROMOTIONS,
    loadChildren: () => import('./feature/promotions/promotions.routes').then((m) => m.promotionsRoutes),
  },
  {
    path: ROUTER_TOKENS.VIDEOS,
    loadChildren: () => import('./feature/videos/videos.routes').then((m) => m.videosRoutes),
  },
  {
    path: ROUTER_TOKENS.NEWS,
    loadChildren: () => import('./feature/news/news.routes').then((m) => m.newsRoutes),
  },
  {
    path: ROUTER_TOKENS.ARTICLE,
    loadChildren: () => import('./feature/article/article.routes').then((m) => m.articleRoutes),
  },
  {
    path: ROUTER_TOKENS.BRANCHES,
    loadChildren: () => import('./feature/branches/branches.routes').then((m) => m.branchesRoutes),
  },
  {
    path: ROUTER_TOKENS.ABOUT_US,
    loadChildren: () => import('./feature/about-us/about-us.routes').then((m) => m.aboutUsRoutes),
  },
  {
    path: ROUTER_TOKENS.GALLERY,
    loadChildren: () => import('./feature/gallery/gallery.routes').then((m) => m.galleryRoutes),
  },
  {
    path: '**',
    component: Lib404PageNotFoundComponent,
  },
];
